import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import ReduxActions from 'reduxActions';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';
import DeleteSuccessMessage from './deleteSuccessMessage';

const SECONDS_LIMIT = 4;

class TaskDeleteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: SECONDS_LIMIT,
    };
  }

  componentDidMount() {
    this._decrementTimer();
  }

  componentWillUnmount() {
    if (!Utils.Helper.isNullOrUndefined(this.timerId)) {
      clearTimeout(this.timerId);
    }
  }

  _decrementTimer() {
    this.timerId = setTimeout(() => {
      this.setState(prevState => ({ seconds: prevState.seconds - 1 }));
      if (this.state.seconds > 0) {
        this._decrementTimer();
      }
      this.timerId = null;
    }, 1000);
  }

  _cancel = () => Utils.Dialog.DialogManager.close();

  _delete() {
    const dataIds = this.props.dataIds;
    const action = this.props.dataIds.length > 1
      ? ReduxActions.task.multipleDelete(this.props.dataIds)
      : ReduxActions.task.delete(this.props.dataIds[0]);
    this.props.dispatch(action)
      .then(() => {
        Utils.Dialog.DialogManager.close();
        Utils.SuccessMessage.SuccessMessageManager.flash((
          <DeleteSuccessMessage
            count={dataIds.length}
          />
        ));
        if (this.props.shouldPopRoute) {
          Utils.Router.pop();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  }

  render() {
    const { dataIds } = this.props;
    const strings = this.props.strings.deleteDialog;
    return (
      <div className="vf-task__delete-dialog">
        <div className="vf-task__delete-dialog__header">
          <Components.CircleIcon
            className="vf-task__delete-dialog__header__icon"
            iconClassName="versa-completed"
            innerIconColor={Theme.Color.$red}
            outerIconColor={Theme.Color.$redlighter}
          />
          <span className="vf-task__delete-dialog__header__text">
            {
              Utils.TranslationHelper.replaceTag(strings.header, {
                count: dataIds.length,
              })
            }
          </span>
        </div>

        <div className="vf-task__delete-dialog__description">
          {strings.line1}
          <br />
          <br />
          {strings.line2}
        </div>

        <div className="vf-task__delete-dialog__buttons">
          <Components.Button
            className="vf-task__delete-dialog__buttons__delete"
            disabled={this.state.seconds > 0}
            iconClassName="versa-delete"
            id="vf-task__delete-dialog__delete-button"
            onClick={() => this._delete()}
          >
            {Utils.TranslationHelper.replaceTag(strings.confirmButton, {
              countdown: this.state.seconds > 0 ? ` (${this.state.seconds})` : '',
            })}
          </Components.Button>
          <Components.Button
            className="vf-task__delete-dialog__buttons__cancel"
            id="vf-task__delete-dialog__cancel-button"
            onClick={this._cancel}
          >
            {strings.cancelButton}
          </Components.Button>
        </div>
      </div>
    );
  }
}

TaskDeleteDialog.displayName = 'Task Delete Dialog';

TaskDeleteDialog.propTypes = {
  dataIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  dispatch: PropTypes.func.isRequired,
  shouldPopRoute: PropTypes.bool,
  strings: PropTypes.shape({
    deleteDialog: PropTypes.shape({
      header: PropTypes.string,
      line1: PropTypes.string,
      line2: PropTypes.string,
      confirmButton: PropTypes.string,
      cancelButton: PropTypes.string,
    }),
  }).isRequired,
};

TaskDeleteDialog.defaultProps = {
  shouldPopRoute: false,
};

export default connect()(translate('Task')(TaskDeleteDialog));
